import { openLink } from './open-link';

/**
 * Download file directly via url
 * @param {string | null} url Url
 */
function downloadDirectlyViaUrl(url) {
  if (url == null) {
    throw new Error('There is no url');
  }
  openLink(url);
}

/**
 * Save a streamed response body as a local file; the `Content-Disposition` filename wins over the default.
 * @param {object} streamedResponseData Streamed response data.
 * @param {object} options Download options.
 * @param {string} options.mimeType Blob MIME type.
 * @param {string} options.defaultFilename Used when the response carries no Content-Disposition filename.
 * @returns {void}
 */
function streamDownloadFile(streamedResponseData, { mimeType, defaultFilename }) {
  const blob = new Blob([streamedResponseData.data], { type: mimeType });
  const blobUrl = window.URL.createObjectURL(blob);

  const contentDisposition = streamedResponseData.headers['content-disposition'];
  let filename = defaultFilename;

  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    if (filenameMatch) {
      const [, extractedFilename] = filenameMatch;
      filename = extractedFilename;
    }
  }

  const link = document.createElement('a');
  document.body.appendChild(link);
  link.style.display = 'none';
  link.href = blobUrl;
  link.download = filename;

  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
}

/**
 * Download certificates as zip file.
 * @param {object} streamedResponseData Streamed response data.
 * @returns {void}.
 */
function streamDownloadCertificatesAsZip(streamedResponseData) {
  streamDownloadFile(streamedResponseData, {
    mimeType: 'application/zip',
    defaultFilename: `certificates_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.zip`,
  });
}

export const downloadFileService = {
  downloadDirectlyViaUrl,
  streamDownloadFile,
  streamDownloadCertificatesAsZip,
};
